import { useState, useEffect } from "react";
import { useAuth, API } from "../App";
import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Loader2, Eye, EyeOff } from "lucide-react";
import axios from "axios";
import { toast } from "sonner";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [seeding, setSeeding] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const seedData = async () => {
      try {
        setSeeding(true);
        await axios.post(`${API}/seed`);
      } catch (error) {
        console.log("Seed data already exists or error:", error);
      } finally {
        setSeeding(false);
      }
    };
    seedData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username || !password) {
      toast.error("يرجى إدخال اسم المستخدم وكلمة المرور");
      return;
    }

    setLoading(true);
    const success = await login(username, password);
    setLoading(false);

    if (success) {
      navigate("/dashboard");
    }
  };

  return (
    <div className="login-container" dir="rtl">
      <div
        className="login-backdrop"
        style={{ backgroundImage: `url('/login-bg.jpg')` }}
      />

      <div className="login-glass-card" data-testid="login-card">
        <div className="flex flex-col items-center mb-9">
          <div className="bg-white rounded-2xl p-3 border border-gray-200 mb-5">
            <img
              src="/lucent-logo.png"
              alt="لوسنت"
              className="w-24 object-contain"
            />
          </div>
          <h1 className="text-2xl font-bold text-[#0A0A0A] tracking-tight mb-1.5">شركة مركز لوسنت للأسنان</h1>
          <p className="text-sm text-gray-500">نظام إدارة المرافق والتشغيل</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="space-y-2">
            <Label htmlFor="username" className="text-[#0A0A0A] font-semibold">اسم المستخدم</Label>
            <Input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="أدخل اسم المستخدم"
              className="text-start h-12 bg-white/80 border-gray-200 rounded-xl"
              disabled={loading || seeding}
              data-testid="username-input"
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="password" className="text-[#0A0A0A] font-semibold">كلمة المرور</Label>
            <div className="relative">
              <Input
                id="password"
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="أدخل كلمة المرور"
                className="text-start h-12 bg-white/80 border-gray-200 rounded-xl pe-11"
                disabled={loading || seeding}
                autoComplete="current-password"
                data-testid="password-input"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute end-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
                data-testid="toggle-password-visibility"
              >
                {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
              </button>
            </div>
          </div>

          <Button
            type="submit"
            className="w-full bg-[#655dc6] hover:bg-[#5049a3] text-white h-12 rounded-xl text-base font-semibold transition-colors"
            disabled={loading || seeding}
            data-testid="login-btn"
          >
            {loading || seeding ? (
              <>
                <Loader2 className="w-5 h-5 animate-spin ms-2" />
                {seeding ? "جاري التحميل..." : "جاري تسجيل الدخول..."}
              </>
            ) : (
              "تسجيل الدخول"
            )}
          </Button>
        </form>

        <p className="text-center text-xs text-gray-400 mt-9">
          © 2026 شركة مركز لوسنت للأسنان
        </p>
      </div>
    </div>
  );
};

export default Login;
